/** Temporary production diagnostics for field calendar — safe to log, never throws. */
export function logFieldCalendarCrash(
  area: string,
  error: unknown,
  context?: Record<string, unknown>,
): void {
  try {
    console.error("[FieldCalendarCrash]", area, error, context ?? {});
  } catch {
    /* ignore */
  }
}

/** URL / returnTo sync diagnostics — never throws. */
export function logFieldCalendarUrlCrash(
  area: string,
  error: unknown,
  context?: Record<string, unknown>,
): void {
  try {
    console.error("[FieldCalendarURLCrash]", {
      area,
      error,
      ...(context ?? {}),
    });
  } catch {
    /* ignore */
  }
}

export function runFieldCalendarSafe<T>(
  area: string,
  fn: () => T,
  fallback: T,
  context?: Record<string, unknown>,
): T {
  try {
    return fn();
  } catch (error) {
    logFieldCalendarCrash(area, error, context);
    return fallback;
  }
}

export function runFieldCalendarUrlSafe<T>(
  area: string,
  fn: () => T,
  fallback: T,
  context?: Record<string, unknown>,
): T {
  try {
    return fn();
  } catch (error) {
    logFieldCalendarUrlCrash(area, error, context);
    return fallback;
  }
}
